import { API, graphqlOperation } from "aws-amplify";
import { updateInvoice } from "../mutations";
import {
  updateInvoiceMini,
  updateInvoiceServiceMini,
} from "./invoice-mutations";

// performDeleteAccount - call graphQl, no try-catch
// handleCreateAccount - with try-catch
// processUpdateAccount - process for lambda

export const sanitizeInvoiceLambda = ({
  account,
  history,
  historyLog,
  inboundShipment,
  lineItems,
  outboundShipment,
  paymentTerm,
  reloadYard,
  ...rest
}) => rest;

// Form saves never write payments: Record Payment owns them, and a page left
// open would otherwise send back a stale list.
export const sanitizeInvoice = (invoice) => {
  const sanitized = sanitizeInvoiceLambda(invoice);
  const { createdAt, updatedAt, payments, paymentReferences, ...rest } =
    sanitized;
  return rest;
};

export const syncableInvoiceCreateProps = [
  { name: "account.externalId", required: false },
  { name: "dueDate", required: false },
  { name: "externalId", required: false },
  { name: "id", required: true },
  { name: "notes", required: false },
  { name: "paymentTerm.code", required: false },
  { name: "invoiceNumber", required: false },
  { name: "taxCode", required: false },
  { name: "lineItems.items", required: true },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.amount/),
    required: true,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.quantity/),
    required: false,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.unitCost/),
    required: false,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.serviceNote/),
    required: false,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.description/),
    required: false,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.serviceName/),
    required: false,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.serviceDate/),
    required: false,
  },

  {
    name: new RegExp(/lineItems\.items\[\d+\]\.tax/),
    required: false,
  },
];

export const syncableInvoiceUpdateProps = [
  { name: "account.externalId", required: false },
  { name: "dueDate", required: false },
  { name: "externalId", required: true },
  { name: "id", required: false },
  { name: "notes", required: false },
  { name: "paymentTerm", required: false },
  { name: "paymentTerm.code", required: false },
  { name: "paymentTermId", required: false },
  { name: "invoiceNumber", required: false },
  { name: "taxCode", required: false },
  { name: "lineItems.items", required: true },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.amount/),
    required: false,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.quantity/),
    required: false,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.unitCost/),
    required: false,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.serviceNote/),
    required: false,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.description/),
    required: false,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.serviceName/),
    required: false,
  },
  {
    name: new RegExp(/lineItems\.items\[\d+\]\.serviceDate/),
    required: false,
  },

  {
    name: new RegExp(/lineItems\.items\[\d+\]\.tax/),
    required: false,
  },
];

// mutations.updateInvoice
export const performUpdateInvoice = async (invoice) => {
  const invoiceInput = sanitizeInvoice(invoice);
  return API.graphql(graphqlOperation(updateInvoice, { input: invoiceInput }));
};

// custom-mutations.updateInventorieMini
export const performUpdateInvoiceMini = async (invoice) => {
  const invoiceInput = sanitizeInvoice(invoice);
  return API.graphql(
    graphqlOperation(updateInvoiceMini, { input: invoiceInput })
  );
};

export const sanitizeInvoiceService = ({
  // aisle,
  area,
  barcodes,
  createdAt,
  inboundShipment,
  inventory,
  location,
  outboundShipment,
  seals,
  service,
  updatedAt,
  zone,
  ...rest
}) => rest;

export const performUpdateInvoiceServiceMini = async (invoiceService) => {
  const invoiceServiceInput = sanitizeInvoiceService(invoiceService);
  return API.graphql(
    graphqlOperation(updateInvoiceServiceMini, { input: invoiceServiceInput })
  );
};
